import createService from './request.js'

// 自动解析 response bizCode === 10000
const service = createService({
  parser(response) {
    const { config, data } = response
    if (config.self) {
      // 外部自行解析
      return data
    } else if (data.bizCode === 10000) {
      return data.data
    } else {
      let { message } = data
      const error = new Error(message)
      error.bizCode = data.bizCode
      return Promise.reject(error)
    }
  }
})

export default service
